import * as React from "react";
import { Namespace, useT } from "@racoon/i18n";
import { ChangePasswordForm } from "@racoon/ui";
import { useNavigate } from "react-router-dom";
import { useGetMeQuery, useResetPasswordMutation } from "~/shared/api/auth/auth.grpc";

export default function ChangePasswordPage() {
  const t = useT();
  const navigate = useNavigate();
  const { data: me } = useGetMeQuery({});
  const [resetPassword, { isLoading, error: apiError }] = useResetPasswordMutation();
  const [success, setSuccess] = React.useState(false);

  const handleSubmit = async (data: { currentPassword: string; newPassword: string }) => {
    if (!me?.user?.id) {
      throw new Error("User ID not found");
    }

    await resetPassword({
      userId: me.user.id,
      oldPassword: data.currentPassword,
      newPassword: data.newPassword,
    }).unwrap();

    setSuccess(true);
  };

  return (
    <div className="flex flex-col h-full w-full">
      <div className="flex-1 overflow-auto">
        <div className="container mx-auto max-w-2xl py-8 px-4">
          <div className="mb-6">
            <h1 className="text-2xl font-semibold text-gray-900 dark:text-gray-100">
              {t(Namespace.Sidebar, "userMenu.changePassword")}
            </h1>
            <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
              {t(Namespace.Common, "changePasswordDescription")}
            </p>
          </div>

          {success && (
            <div className="mb-6 rounded-md bg-green-50 dark:bg-green-900/20 p-4">
              <p className="text-sm text-green-600 dark:text-green-400">
                {t(Namespace.Common, "changePasswordSuccess")}
              </p>
            </div>
          )}

          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <ChangePasswordForm
              onSubmit={handleSubmit}
              isLoading={isLoading}
              error={apiError ? t(Namespace.Common, "changePasswordError") : undefined}
              onCancel={() => navigate(-1)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
